import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Step,
    StepLabel,
    Stepper
} from "@mui/material";
import React, {useEffect, useState} from "react";

import Box from "@mui/material/Box";
import UserSupplierMaterialService from "../../../../../../API/orders/warehouse/material/UserSupplierMaterialService";
import SupplierTable from "../../supplier/SupplierTable";
import ArrivalMaterialTextField from "../arrival/ArrivalMaterialTextField";
import TextFieldObjectWithSupplierMaterialList from "./TextFieldObjectWithSupplierMaterialList";
import MaterialPriceUnitUtil from "../../../../../../utils/warehouse/MaterialPriceUnitUtil";
import {setMaterialPriceUnit} from "../arrival/ModalAddMaterialPriceUnitModule";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import ButtonBack from "../../../../button/ButtonBack";
import Typography from "@mui/material/Typography";

const steps = [
    'Постащик',
    'Тип поставки',
    'Размеры',
];

const createEmptyMaterialPriceUnit = () => ({...MaterialPriceUnitUtil.materialPriceUnit});

function setMaterialPriceUnitByFound(foundMaterial, id, setIsFixedStripe, setIsFixedWhole,
                                     baseCurrency, alternativeCurrency, setPrice, currencyMap, handleModalAlert, setDataFormat, currenciesData, setCurrenciesData, materialWidth) {
    if (!foundMaterial) {
        console.warn(`Material with id ${id} not found`);
        return;
    }

    setIsFixedStripe(foundMaterial.typeSupplierMaterial === "BY_FIXED_STRIPE");
    setIsFixedWhole(foundMaterial.typeSupplierMaterial === "WHOLE");

    const materialPriceUnit = createEmptyMaterialPriceUnit();
    setDataFormat(prev => ({
        ...prev,
        supplierMaterial: foundMaterial,
        supplierMaterialId: id,
        materialPriceUnit
    }));

    const basePrice = foundMaterial.basePrice;
    const currentCurrency = currencyMap.get(basePrice.currencyId).curAbbreviation;
    setMaterialPriceUnit(basePrice, setPrice,
        currentCurrency, baseCurrency,
        alternativeCurrency,
        foundMaterial,
        null,
        true,
        materialPriceUnit,
        false,
        true,
        currencyMap, handleModalAlert, setDataFormat, currenciesData, setCurrenciesData, materialWidth);
}

function getAndSetSupplierMaterials(data, supplier, setSupplierMaterials, setIsFixedStripe, setIsFixedWhole,
                                    baseCurrency, alternativeCurrency, setPrice, currencyMap, handleModalAlert, setDataFormat, currenciesData, setCurrenciesData, materialWidth) {
    const supplierMaterials = data.get(supplier.id);
    setSupplierMaterials(supplierMaterials);
    setMaterialPriceUnitByFound(supplierMaterials[0],
        supplierMaterials[0].id, setIsFixedStripe, setIsFixedWhole,
        baseCurrency, alternativeCurrency, setPrice, currencyMap, handleModalAlert, setDataFormat, currenciesData, setCurrenciesData, materialWidth);
}

const ModalAddWarehouseMaterial = ({
                                       open, onClose, title, materialId,
                                       supplierMaterials, setSupplierMaterials,
                                       dataSuppliers, setDataSuppliers,
                                       baseCurrency, alternativeCurrency,
                                       handleSubmitCreate,
                                       currencyMap,
                                       handleModalAlert,
                                       materialWidth,
                                       buttonName,
                                       loading
                                   }) => {


    const [activeStep, setActiveStep] = useState(0)
    const [data, setData] = useState([])
    const [isFixedStripe, setIsFixedStripe] = useState(false)
    const [isFixedWhole, setIsFixedWhole] = useState(false)
    const [price, setPrice] = useState([])

    const [currenciesData, setCurrenciesData] = useState({})

    const [dataFormat, setDataFormat] = useState({
        note: null,
        supplier: null,
        supplierMaterialId: null,
        supplierMaterial: null,
        materialPriceUnit: createEmptyMaterialPriceUnit()
    })

    const [validationError, setValidationError] = useState("")

    const setCurrentSupplier = (value) => {
        setValidationError("")
        const newData = data.get(value.id)[0]
        const supplier = newData.supplier
        setDataFormat(prev => ({...prev, supplier}))
        getAndSetSupplierMaterials(data, supplier, setSupplierMaterials,
            setIsFixedStripe, setIsFixedWhole, baseCurrency, alternativeCurrency, setPrice, currencyMap, handleModalAlert, setDataFormat, currenciesData, setCurrenciesData, materialWidth);
    }
    const setSupplierMaterial = (id) => {
        setValidationError("")
        const foundMaterial = supplierMaterials.find(material => material.id.toString() === id);
        setMaterialPriceUnitByFound(foundMaterial,
            id, setIsFixedStripe, setIsFixedWhole, baseCurrency, alternativeCurrency, setPrice, currencyMap, handleModalAlert, setDataFormat, currenciesData, setCurrenciesData, materialWidth);
    }

    useEffect(() => {
        if (!open) {
            return;
        }
        setDataFormat({
            note: null,
            supplier: null,
            supplierMaterialId: null,
            supplierMaterial: null,
            materialPriceUnit: createEmptyMaterialPriceUnit()
        });
        setValidationError("");
        setActiveStep(0);

        UserSupplierMaterialService.getAllByMaterialOrganizationOption(materialId)
            .then(response => {
                const rawData = response.data;
                const supplierMap = new Map();
                rawData.forEach(item => {
                    const supplierKey = item.supplier.id;
                    if (!supplierMap.has(supplierKey)) {
                        supplierMap.set(supplierKey, []);
                    }
                    supplierMap.get(supplierKey).push(item);
                });
                setData(supplierMap);
                const suppliersArray = Array.from(supplierMap.values()).map(items => items[0].supplier);
                setDataSuppliers(suppliersArray);
                setDataFormat(prev => ({...prev, supplier: suppliersArray[0]}));
                getAndSetSupplierMaterials(supplierMap, suppliersArray[0], setSupplierMaterials,
                    setIsFixedStripe, setIsFixedWhole, baseCurrency, alternativeCurrency, setPrice, currencyMap, handleModalAlert, setDataFormat, currenciesData, setCurrenciesData, materialWidth);
            })
            .catch(error => {
                handleModalAlert(error);
            });
    }, [open, materialId, baseCurrency, alternativeCurrency, materialWidth]);

    const submit = () => {
        if (activeStep < 2) {
            setActiveStep(activeStep + 1);
        } else {
            const supplierMaterial = dataFormat.materialPriceUnit?.supplierMaterial ?? dataFormat.supplierMaterial;
            const maxHeight = materialWidth - supplierMaterial.width;
            if (supplierMaterial.typeSupplierMaterial === "BY_MIN_STRIPE" && (maxHeight < +dataFormat.materialPriceUnit.width)) {
                setValidationError(`высота должна быть не более ${maxHeight}мм`)
            } else {
                handleSubmitCreate(dataFormat, reset);
            }
        }
    }

    const reset = () => {
        setActiveStep(0)
        onClose()
        setValidationError("")
    }

    const back = () => {
        if (activeStep > 0) {
            setActiveStep(activeStep - 1);
        } else {
            onClose();
        }
    }


    const setField = (value) => {
        setDataFormat(prev => ({...prev, materialPriceUnit: value}))
    }
    const setNote = (value) => {
        setDataFormat(prev => ({...prev, note: value.note}))
    }


    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${activeStep === 0 ? "40vw" : "700px"}`,
                height: `${activeStep === 0 ? "800px" : activeStep === 1 ? "500px" : "700px"}`
            }
        }}>
            <Box style={{
                padding: 40,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{title}</DialogTitle>
                <Stepper
                    style={{width: 600}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <Box sx={{
                height: "32px",
                fontSize: "18px",
                margin: "0px 40px 0px 40px",
                display: "flex",
                alignItems: "center",
                borderBottom: dataFormat.supplier ? "#3B8BEC 1px solid" : "transparent 1px solid",
                '& .MuiTypography-root': {
                    fontWeight: (theme) => theme.typography.fontWeight,
                    color: (theme) => theme.palette.text.main,
                    '&:first-of-type': {
                        marginRight: '10px'
                    }
                },
            }}>
                <Typography
                    component="p">{dataFormat.supplier !== null && dataFormat.supplier !== undefined ? dataFormat.supplier.name : ""}</Typography>
            </Box>
            <DialogContent sx={{paddingBottom: 0}}>
                {activeStep === 0 ?
                    <Box>
                        {dataSuppliers && dataFormat && <SupplierTable
                            data={dataSuppliers}
                            selectId={dataFormat?.supplier?.id}
                            select={setCurrentSupplier}
                        />}
                    </Box>
                    : activeStep === 1 ?
                        <Box style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
                            <Box style={{paddingTop: 20}}>
                                <TextFieldObjectWithSupplierMaterialList
                                    label="Тип поставки"
                                    values={dataFormat}
                                    field={'supplierMaterialId'}
                                    setId={setSupplierMaterial}
                                    entityList={supplierMaterials}
                                    name={'typeSupplierMaterial'}
                                    materialWidth={materialWidth}
                                />
                            </Box>
                        </Box> :
                        <Box>
                            <Stack
                                sx={{
                                    width: '100%',
                                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                    gap: '0.01rem',
                                }}
                            >
                                <ArrivalMaterialTextField
                                    label="Количество"
                                    values={dataFormat.materialPriceUnit}
                                    field={'quantity'}
                                    disabled={true}

                                />
                                <ArrivalMaterialTextField
                                    label="Ширина"
                                    values={dataFormat.materialPriceUnit}
                                    setValues={setField}
                                    field={'length'}
                                    type={"number"}
                                    disabled={isFixedWhole || isFixedStripe}
                                />
                                <ArrivalMaterialTextField
                                    label="Высота"
                                    values={dataFormat.materialPriceUnit}
                                    setValues={setField}
                                    field={'width'}
                                    type={"number"}
                                    validationError={validationError}
                                    setValidationState={setValidationError}
                                    disabled={isFixedWhole || isFixedStripe}
                                />
                                <ArrivalMaterialTextField
                                    label={`Сумма в ${price}`}
                                    values={dataFormat.materialPriceUnit}
                                    field={'amountInCurrencyArrival'}
                                    disabled={true}
                                />
                                <ArrivalMaterialTextField
                                    label="Комментарий"
                                    values={dataFormat}
                                    setValues={setNote}
                                    field={'note'}
                                />
                            </Stack>
                        </Box>
                }
            </DialogContent>

            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 && <ButtonBack text={"Назад"} onClick={back}/>} </Box>
                <Box>
                    <ButtonExit text={"Выйти"} onClick={reset}/>
                    <ButtonAdd
                        loading={loading}
                        text={activeStep === 2 ? buttonName : "Выбрать"}
                        disabled={activeStep === 2 && (dataFormat.materialPriceUnit.supplierMaterial == null || validationError)}
                        onClick={submit}/>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default ModalAddWarehouseMaterial